// extracted by mini-css-extract-plugin
export default {"container":"RootLayout_container__arUtK"};